import { useNavigate, useParams } from 'react-router-dom';
import {
  CreateTermineDrawer,
  CreateTermineSheet,
  CreateTermineSheetWrapper,
  CreateTermineDrawerWrapper,
} from '@/domain/termine/features';
import { CreateTermineFormProvider } from '@/domain/termine/features/CreateTermin/shared/CreateTermineFormProvider';

export function CreateTermineWrapper() {
  const navigate = useNavigate();
  const { year, month } = useParams<{ year: string; month: string }>();
  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  function handleClose() {
    navigate(`/termine/uebersicht/${year}/${month}`);
  }

  return isMobile ? (
    <CreateTermineDrawerWrapper onClose={handleClose}>
      <CreateTermineFormProvider>
        <CreateTermineDrawer />
      </CreateTermineFormProvider>
    </CreateTermineDrawerWrapper>
  ) : (
    <CreateTermineSheetWrapper onClose={handleClose}>
      <CreateTermineFormProvider>
        <CreateTermineSheet />
      </CreateTermineFormProvider>
    </CreateTermineSheetWrapper>
  );
}
